import React, { useRef } from "react";

interface ItemImageUploaderProps {
  file: File | null;
  previewUrl?: string | null;
  error?: string;
  onFileSelected: (file: File | null) => void;
  buttonLabel?: string;
  showButton?: boolean;
  fontFamily?: string;
  borderColor?: string;
  primaryTextColor?: string;
  secondaryTextColor?: string;
  accentColor?: string;
}

export function ItemImageUploader({
  file,
  previewUrl,
  error,
  onFileSelected,
  buttonLabel = "Upload Image",
  showButton = true,
  fontFamily = "Arial, sans-serif",
  borderColor = "rgba(255, 255, 255, 0.1)",
  primaryTextColor = "rgba(255, 255, 255, 0.95)",
  secondaryTextColor = "rgba(255, 255, 255, 0.7)",
  accentColor = "rgb(56, 189, 248)",
}: ItemImageUploaderProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
      data-oid="n:gp8vm"
    >
      <input
        ref={inputRef}
        type="file"
        accept=".png,.jpg,.jpeg,.webp"
        aria-label="Upload image"
        hidden
        onChange={(event) => onFileSelected(event.target.files?.[0] ?? null)}
        data-oid="hiz.v.s"
      />

      {showButton ? (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
            padding: "0.75rem 1rem",
            borderRadius: "9999px",
            border: `1px solid ${borderColor}`,
            background: accentColor,
            color: "#ffffff",
            fontSize: "0.75rem",
            fontWeight: 700,
            fontFamily,
            cursor: "pointer",
            textTransform: "uppercase",
          }}
          data-oid="8wsjjrp"
        >
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "1rem", fontWeight: 300 }}
            data-oid="10qgff2"
          >
            upload
          </span>
          {buttonLabel}
        </button>
      ) : null}
      {previewUrl ? (
        <p
          style={{
            margin: 0,
            fontSize: "0.75rem",
            color: secondaryTextColor,
            fontFamily,
          }}
          data-oid=":6.b25r"
        >
          {file?.name ?? "Preview ready"}
        </p>
      ) : null}
      {error ? (
        <p
          id="item-image-error"
          role="alert"
          style={{
            margin: 0,
            fontSize: "0.75rem",
            color: "#f87171",
            fontFamily,
          }}
          data-oid="ux9te7-"
        >
          {error}
        </p>
      ) : null}
      {!error && file ? (
        <p
          style={{
            margin: 0,
            fontSize: "0.75rem",
            color: primaryTextColor,
            fontFamily,
          }}
          data-oid="1pdpy5j"
        >
          {file.name}
        </p>
      ) : null}
    </div>
  );
}
